import React from 'react';

import DropDown from 'src/components/common/field/DropDown';
import { statuses } from 'src/components/master/Common';

const sxlabelDropdown = {
  '&.Mui-focused': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
  '&.MuiInputLabel-root': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
};

const sizeDropdown = {
  width: '160px',
  height: '32px'
};

type DropDownStatusnProps = {
  selected: number | string | null;
  onChange: (id: number | string) => void;
};

const DropDownStatus: React.FC<DropDownStatusnProps> = (props) => {

  return (
    <DropDown
      selected={props.selected}
      idSelect='status'
      placeholder='ステータス'
      defaultSelect={'選択する'}
      onChange={props.onChange}
      sxInput={sizeDropdown}
      sxLabel={sxlabelDropdown}
      items={statuses}
    />
  );
}

export default DropDownStatus;
